import { render } from "./DocumentationModal.vue?vue&type=template&id=5563cd29&scoped=true"
import script from "./DocumentationModal.vue?vue&type=script&lang=js"
export * from "./DocumentationModal.vue?vue&type=script&lang=js"

import "./DocumentationModal.vue?vue&type=style&index=0&id=5563cd29&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5563cd29"]])

export default __exports__